import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const brokeredLoadMarkAsVoidedAtom = createMutationAtomFactory(
  'brokerage.brokeredLoadMarkAsVoided',
  (params: { loadId?: string }) => ({
    tradeLoadVoid: {
      __args: {
        id: params.loadId ?? '',
      },
    },
  }),
  {
    skipQueue: true,
  },
);
